import Marquee from "react-fast-marquee";

const items = [
  "Elektrik Dahil",
  "Su Dahil",
  "Doğalgaz Dahil",
  "Yüksek Hızlı İnternet",
  "Aidat Dahil",
  "Kahvaltı Dahil",
  "Temizlik Hizmeti",
  "Komisyon Yok",
];

const InclusiveMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="py-6 sm:py-8 bg-[#E2D9C8] overflow-hidden"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <div key={i} className="marquee-item">
            <span className="marquee-dot" />
            <span>{item}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default InclusiveMarquee;
